var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('van-empty',{attrs:{"image":"error","description":"用户身份获取失败"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }